// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AddTenantRequestDTO } from '../models';
import { TenancyDTO } from '../models';
/**
 * TenantsApi - axios parameter creator
 * @export
 */
export const TenantsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a new tenant to a tenancy
         * @param {string} tenancyId Tenancy id
         * @param {AddTenantRequestDTO} addTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenant(tenancyId: string, addTenantRequestDTO: AddTenantRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling addTenant.');
            }
            // verify required parameter 'addTenantRequestDTO' is not null or undefined
            if (addTenantRequestDTO === null || addTenantRequestDTO === undefined) {
                throw new RequiredError('addTenantRequestDTO','Required parameter addTenantRequestDTO was null or undefined when calling addTenant.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenants`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"AddTenantRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(addTenantRequestDTO !== undefined ? addTenantRequestDTO : {}) : (addTenantRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete tenant by tenancyUserId or tenancyInviteId
         * @param {string} tenantId 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(tenantId: string, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenantId' is not null or undefined
            if (tenantId === null || tenantId === undefined) {
                throw new RequiredError('tenantId','Required parameter tenantId was null or undefined when calling deleteById.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling deleteById.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenants/{tenantId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenantsApi - functional programming interface
 * @export
 */
export const TenantsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a new tenant to a tenancy
         * @param {string} tenancyId Tenancy id
         * @param {AddTenantRequestDTO} addTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenant(tenancyId: string, addTenantRequestDTO: AddTenantRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenantsApiAxiosParamCreator(configuration).addTenant(tenancyId, addTenantRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete tenant by tenancyUserId or tenancyInviteId
         * @param {string} tenantId 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(tenantId: string, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyDTO> {
            const localVarAxiosArgs = TenantsApiAxiosParamCreator(configuration).deleteById(tenantId, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenantsApi - factory interface
 * @export
 */
export const TenantsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a new tenant to a tenancy
         * @param {string} tenancyId Tenancy id
         * @param {AddTenantRequestDTO} addTenantRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTenant(tenancyId: string, addTenantRequestDTO: AddTenantRequestDTO, options?: any) {
            return TenantsApiFp(configuration).addTenant(tenancyId, addTenantRequestDTO, options)(axios, basePath);
        },
        /**
         * Delete tenant by tenancyUserId or tenancyInviteId
         * @param {string} tenantId 
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(tenantId: string, tenancyId: string, options?: any) {
            return TenantsApiFp(configuration).deleteById(tenantId, tenancyId, options)(axios, basePath);
        },
    };
};

/**
 * TenantsApi - interface
 * @export
 * @interface TenantsApi
 */
export interface TenantsApiInterface {
    /**
     * Add a new tenant to a tenancy
     * @param {string} tenancyId Tenancy id
     * @param {AddTenantRequestDTO} addTenantRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    addTenant(tenancyId: string, addTenantRequestDTO: AddTenantRequestDTO, options?: any): AxiosPromise<TenancyDTO>;

    /**
     * Delete tenant by tenancyUserId or tenancyInviteId
     * @param {string} tenantId 
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApiInterface
     */
    deleteById(tenantId: string, tenancyId: string, options?: any): AxiosPromise<TenancyDTO>;

}

/**
 * TenantsApi - object-oriented interface
 * @export
 * @class TenantsApi
 * @extends {BaseAPI}
 */
export class TenantsApi extends BaseAPI implements TenantsApiInterface {
    /**
     * Add a new tenant to a tenancy
     * @param {string} tenancyId Tenancy id
     * @param {AddTenantRequestDTO} addTenantRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public addTenant(tenancyId: string, addTenantRequestDTO: AddTenantRequestDTO, options?: any) {
        return TenantsApiFp(this.configuration).addTenant(tenancyId, addTenantRequestDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete tenant by tenancyUserId or tenancyInviteId
     * @param {string} tenantId 
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantsApi
     */
    public deleteById(tenantId: string, tenancyId: string, options?: any) {
        return TenantsApiFp(this.configuration).deleteById(tenantId, tenancyId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenantsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Add a new tenant to a tenancy
 * @param {string} tenancyId Tenancy id
 * @param {AddTenantRequestDTO} addTenantRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addTenant(
    tenancyId: string,
    addTenantRequestDTO: AddTenantRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenantsApiAxiosParamCreator(configuration).addTenant(tenancyId, addTenantRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete tenant by tenancyUserId or tenancyInviteId
 * @param {string} tenantId 
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteById(
    tenantId: string,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyDTO> {
    const localVarAxiosArgs = TenantsApiAxiosParamCreator(configuration).deleteById(tenantId, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

